/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'FormPreviewBackground',
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"form-preview-background"},[_c('path',{attrs:{"fill":"white","d":"M88 104C88 99.5817 91.5817 96 96 96H752C756.418 96 760 99.5817 760 104V838H88V104Z"}}),_c('rect',{attrs:{"fill":"white","rx":"6.77419","height":"54","width":"366","y":"212","x":"241"}}),_c('rect',{attrs:{"fill":"white","height":"53.629","width":"365.435","y":"212.282","x":"241.282"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"167","y":"223","x":"295"}}),_c('rect',{attrs:{"stroke-width":"0.564516","stroke":"#DDDDDD","rx":"6.49194","height":"53.4355","width":"365.435","y":"212.282","x":"241.282"}}),_c('rect',{attrs:{"fill":"white","rx":"6.49194","height":"175.5","width":"365.435","y":"278.282","x":"241.282"}}),_c('rect',{attrs:{"fill":"#DDDDDD","rx":"3","height":"11","width":"74","y":"287.032","x":"250.032"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"89","y":"310.032","x":"250.032"}}),_c('rect',{attrs:{"stroke":"#DDDDDD","rx":"4.5","height":"21","width":"346.935","y":"325.532","x":"250.532"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"89","y":"359.032","x":"250.032"}}),_c('rect',{attrs:{"stroke":"#DDDDDD","rx":"4.5","height":"21","width":"346.935","y":"374.532","x":"250.532"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"11","width":"89","y":"408.032","x":"250.032"}}),_c('rect',{attrs:{"stroke":"#DDDDDD","rx":"4.5","height":"21","width":"346.935","y":"423.532","x":"250.532"}}),_c('rect',{attrs:{"stroke-width":"0.564516","stroke":"#DDDDDD","rx":"6.49194","height":"175.5","width":"365.435","y":"278.282","x":"241.282"}}),_c('rect',{attrs:{"fill":"#FF7715","rx":"5","height":"24","width":"366","y":"466.064","x":"241"}}),_c('rect',{attrs:{"fill":"#F3F3F3","rx":"3","height":"6","width":"210","y":"496","x":"319"}})])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FormPreviewBackground.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__